import { render, staticRenderFns } from "./ControlButton.vue?vue&type=template&id=2a373c3f&scoped=true&"
import script from "./ControlButton.vue?vue&type=script&lang=js&"
export * from "./ControlButton.vue?vue&type=script&lang=js&"
import style0 from "./ControlButton.vue?vue&type=style&index=0&id=2a373c3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a373c3f",
  null
  
)

export default component.exports